import { useEffect, useCallback, useState, RefObject } from 'react';
import { SUBHEADER_STICKY_HEIGHT } from '@/components/SubHeader/SubHeader';

const useSidebarHeight = ({
  isStickyHeader,
  sidebarRef,
  subHeaderRef,
}: {
  isStickyHeader: boolean;
  sidebarRef: RefObject<HTMLDivElement>;
  subHeaderRef: RefObject<HTMLDivElement>;
}) => {
  const [subHeaderHeight, setSubHeaderHeight] = useState(0);
  const [fullHeaderHeight, setFullHeaderHeight] = useState<number | null>(null);

  useEffect(() => {
    if (subHeaderRef.current) {
      setSubHeaderHeight(subHeaderRef.current.getBoundingClientRect().height);
    }
  }, [subHeaderRef]);

  const calculateFullHeaderHeight = useCallback(() => {
    const sidebar = sidebarRef.current;

    if (sidebar) {
      let newHeaderHeight;
      if (isStickyHeader) {
        newHeaderHeight = (subHeaderRef.current?.offsetTop || 0) + SUBHEADER_STICKY_HEIGHT;
      } else {
        const scrollTop = subHeaderRef.current?.getBoundingClientRect().y || 0;
        newHeaderHeight = subHeaderHeight + scrollTop;
      }

      setFullHeaderHeight(newHeaderHeight);
    }
  }, [isStickyHeader, sidebarRef, subHeaderHeight, subHeaderRef]);

  useEffect(() => {
    calculateFullHeaderHeight();
    if (!isStickyHeader) {
      window.addEventListener('scroll', calculateFullHeaderHeight);
    }
    window.addEventListener('resize', calculateFullHeaderHeight);

    return () => {
      window.removeEventListener('scroll', calculateFullHeaderHeight);
      window.removeEventListener('resize', calculateFullHeaderHeight);
    };
  }, [calculateFullHeaderHeight, isStickyHeader, subHeaderHeight]);

  return { sidebarHeight: `calc(100vh - ${fullHeaderHeight}px)` };
};

export default useSidebarHeight;
